"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _lodash = _interopRequireDefault(require("lodash"));

var _styles = require("@mui/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectMultipleAa({
  agregado,
  onChange
}) {
  const {
    multiple,
    opciones,
    descripcion
  } = agregado;
  const theme = (0, _styles.useTheme)();
  const classes = (0, _styles2.default)(theme);
  return (0, _react2.jsx)("div", {
    className: classes.root
  }, (0, _react2.jsx)(_material.Select, {
    variant: "standard",
    multiple: multiple,
    fullWidth: true,
    value: descripcion || [],
    onChange: event => onChange('descripcion', event.target.value, agregado)
  }, _lodash.default.map(opciones, item => (0, _react2.jsx)(_material.MenuItem, {
    value: item.value,
    key: item.value
  }, item.label))));
}

var _default = SelectMultipleAa;
exports.default = _default;